import classNames from 'classnames'
import React from 'react'

import styles from '../Body.module.scss'

interface ConfirmationBannerProps {
  date: string | Date | null
  formatDateTime: (d: string | Date) => string
}

export const ConfirmationBanner: React.FC<ConfirmationBannerProps> = ({ date, formatDateTime }) => {
  if (!date) return null
  return (
    <div className={classNames(styles.confirmation, styles.success, styles.alignCenter)}>
      T&C were signed at {formatDateTime(date)}
    </div>
  )
}
